import React from "react";
import FormElementLabel from "./FormElementLabel";
import ErrorMessage from "./ErrorMessage";
import { cn } from "../helpers";
import { useFormContext } from "react-hook-form";

const FormInput: React.FC<{
  name: string;
  // value: string;
  label?: string;
  placeholder?: string;
  errorMessage?: string;
  type?: React.HTMLInputTypeAttribute;
  toolTipText?: string;
  disabled?: boolean;
  required?: boolean;
  // onChange: React.ChangeEventHandler<HTMLInputElement>;
  // onBlur?: React.FocusEventHandler<HTMLInputElement>;
}> = ({
  label,
  placeholder,
  name,
  errorMessage,
  type = "text",
  disabled = false,
  required = false,
}) => {
  const { register, formState, resetField } = useFormContext();

  const isTouched = formState?.touchedFields[name];
  const hasError = !!formState.errors?.[name];

  return (
    <div className="text-left">
      <div className="flex flex-row [&>*:first-child]:mr-2">
        {!!label && (
          <FormElementLabel label={`${label} ${required ? "*" : ""}`} />
        )}
      </div>
      <input
        placeholder={placeholder}
        type={type}
        {...register(name)}
        className={cn(
          "peer block w-full rounded-2xl py-3 bg-pitchlerGray border-none focus:ring-0 focus:border-primary smallTablet:text-md smallTablet:leading-6"
        )}
        disabled={disabled}
        required={required}
      />
      <div className="mb-3">
        {hasError && errorMessage && <ErrorMessage message={errorMessage} />}
      </div>
    </div>
  );
};

export default FormInput;
